import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/index.css");
